import React from "react";
import "./wel.scss"
import CheckBox from "../../components/inputs/CheckBox";
import {Link} from "react-router-dom";

export function Fz152(){
    return (
        <div className='welcomepage'>
            <div className='imgback'>
                <div className='welcomepage_white'>
                    <div className="title"><b>Согласие на обработку персональных данных</b></div>
                    <div className="welcomepage_white_mess">


                        Я, даю свое согласие Общество с ограниченной ответственностью «Сургутское ремонтно – строительное управление», адрес: 628452, РФ, Тюменская обл., Сургутский р-н, с.п. Солнечный, ул. (операцию) или совокупность действий (операций), совершаемых с использованием средств
                        автоматизации или без использования таких средств с персональными данными, включая сбор, запись,
                        систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование,
                        передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление,
                        уничтожение), запись на электронные носители, в том числе при использовании сетевого ресурса
                        srsuportal.ru, следующих персональных данных:
                        <br />
                        1) фамилию, имя, отчество (в том числе прежние фамилия, имя или отчество в случае их
                        изменения, когда, где и по какой причине изменяли);<br />
                        2) число, месяц, год рождения;<br />
                        3) место рождения;<br />
                        4) паспортные данные (серия, номер, кем и когда выдан, код подразделения), индивидуальны
                        номер налогоплательщика, страховой номер индивидуального лицевого счета;<br />
                        5) адрес регистрации;<br />
                        6) контактный номер телефона;<br />
                        7) адрес электронной почты;<br />
                        8) сведения об образовании, в том числе о послевузовском профессиональном образовании
                        (наименование и год окончания образовательного учреждения, наименование и реквизиты документа об
                        образовании, квалификация, специальность по документу об образовании и т.п.);<br />
                        9) сведения о профессиональной переподготовке, повышении квалификации и аттестации
                        (номера и даты выдачи документов, наименование учреждения (органа), выдавшего документ);<br />
                        10) сведения о работодателе (ИНН, ОГРН, полное наименование, адрес);<br />
                        11) сведения о занимаемой должности, вид трудовых отношений с работодателем, согласно
                        трудового договора, номер и дата трудового договора;<br />
                        12) сведения о табельном номере, количестве отработанного времени, о предоставляемых и
                        использованных отпусках, начисленной заработной плате, налоговых отчислениях, сборов и взносов на
                        обязательное социальное и пенсионное страхование;<br />
                        13) сведения о трудовом стаже и предыдущих местах работы;<br />
                        14) биометрические данные (фотографическое/видео изображение).<br />
                        Вышеуказанные персональные данные предоставляю Оператору для обработки в целях
                        осуществления и выполнения ООО «Сургутское РСУ» функций, полномочий и обязанностей в сфере
                        предпринимательской деятельности.
                        Настоящее согласие действует в течение всего срока осуществления ООО «Сургутское РСУ»
                        предпринимательской деятельности. Персональные данные хранятся бессрочно. Оставляю за собой право
                        отозвать свое согласие посредством составления соответствующего письменного документа, который
                        может быть направлен мной в адрес Оператора по почте заказным письмом с уведомлением о вручении,
                        либо вручен лично под расписку представителю Оператора.<br />
                    </div>
                    <div className="welcomepage_white_btns">
                        <Link to={'/welcome?ok=true'} className="welcomepage_white_btns_ok">Принять и продолжить</Link>
                    </div>
                </div>
            </div>

        </div>
    )
}